export const GETME_START = 'GETME_START';
export const GETME_SUCCESS = 'GETME_SUCCESS';
export const GETME_FAIL = 'GETME_FAIL';
export const GETME_RESET = 'GETME_RESET';
